import DialogActions from '@material-ui/core/DialogActions';
import { View } from '@zinc/ui';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import FlatButton from '../../../../general/flatButton';

export interface IAction {
  text: string;

  onClick: () => void;
}

interface IProps {
  dataTestIdPrefix?: string;
  actions?: (JSX.Element | IAction)[];
}

@observer
class Actions extends React.Component<IProps> {
  render() {
    let { actions } = this.props;

    if (!this.show) {
      return null;
    }

    const content = actions?.map((x, idx) => {
      if (React.isValidElement(x)) {
        return x;
      }

      const { text, onClick } = x as IAction;
      return <FlatButton key={idx} label={text} tabIndex={0} onClick={onClick} />;
    });

    return (
      <DialogActions data-testid={this.dataTestId}>
        <View gap={2} direction="row" justify="end" align="stretch">
          {content}
        </View>
      </DialogActions>
    );
  }

  @computed
  private get show(): boolean {
    let { actions = [] } = this.props;
    return actions.length > 0;
  }

  @computed
  private get dataTestId(): string {
    const { dataTestIdPrefix } = this.props;

    if (!dataTestIdPrefix) {
      return '';
    }

    return `${dataTestIdPrefix}-actions`;
  }
}

export default Actions;
